export default "__VITE_ASSET__xJxie5Wl__"